/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popWithdraw.vue?vue&type=template&id=2ced4d5a&scoped=true"
import script from "./popWithdraw.vue?vue&type=script&lang=js"
export * from "./popWithdraw.vue?vue&type=script&lang=js"
import style0 from "./popWithdraw.vue?vue&type=style&index=0&id=2ced4d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced4d5a",
  null
  
)

export default component.exports